export enum actionTypes{
    REQUEST_ONETIMEPASSWORD="request_onetimepassword",
    RECEIVE_ONETIMEPASSWORD="receive_onetimepassword",
    REQUEST_MFA_ONETIMEPASSWORD_LENGTH="request_mfa_onetimepassword_length",
    RECEIVE_MFA_ONETIMEPASSWORD_LENGTH="receive_mfa_onetimepassword_length",
    REQUEST_VALIDATE_ONETIMEPASSWORD="request_validate_onetimepassword",
    COMPLETED_VALIDATE_ONETIMEPASSWORD="completed_validate_onetimepassword",
}